import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvcPrivateLayoutService } from './private-layout.service';
import { SvcPrivateLayoutComponent } from './private-layout.component';


@NgModule({
  declarations: [
    SvcPrivateLayoutComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    SvcPrivateLayoutComponent,
  ],
  providers: [
    SvcPrivateLayoutService,
  ],
})
export class PrivateLayoutModule { }
